const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type StoreAssignmentBoardStoreItem = {
  id: number;
  storeName: string;
  isActive: boolean;
};

export type StoreAssignmentBoardUserItem = {
  id: string;
  name: string;
  email: string;
  department: string | null;
  roleId: number;
  roleName: string;
  positionName: string | null;
  isActive: boolean;
};

export type StoreAssignmentItem = {
  storeId: number;
  userId: string;
  createdAt: string;
};

export type StoreAssignmentBoardResponse = {
  stores: StoreAssignmentBoardStoreItem[];
  users: StoreAssignmentBoardUserItem[];
  assignments: StoreAssignmentItem[];
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message =
    typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchStoreAssignmentBoard() {
  const response = await fetch(`${apiBaseUrl}/api/admin/store-assignments/board`);
  await throwIfNotOk(response);
  return (await response.json()) as StoreAssignmentBoardResponse;
}

export async function assignUserToStore(input: {
  storeId: number;
  userId: string;
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/store-assignments`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function unassignUserFromStore(userId: string, storeId?: number) {
  const params = new URLSearchParams();
  if (typeof storeId === 'number') {
    params.set('storeId', String(storeId));
  }
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const response = await fetch(`${apiBaseUrl}/api/admin/store-assignments/${userId}${suffix}`, {
    method: 'DELETE',
  });
  await throwIfNotOk(response);
}
